module.exports = __webpack_public_path__ + "static/img/empty.0c872889.svg";